import "../img/employers/apprenticeship-levy-overlap.png";
import "../img/employers/employers-banner.png";
import "../img/icons/employer-icon.jpg";
import "../img/videos/hire-an-apprentice.png";
import "../img/videos/hire-an-apprentice.mp4";
